import React, { Component } from "react";
import { connect } from "react-redux";
import {
  loveImage,
  unloveImage,
} from "../../utilities/reducers/favorite-redux";
import FashionIcon from "../FashionIcon";
import MembershipModalRedux from "@xo-union/tk-component-membership-modal-redux";

export class FavoriteComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openModalType: null,
      renderMembershipModal: false,
    };

    this.handleClickHeart = this.handleClickHeart.bind(this);
    this.onClickLogIn = this.onClickLogIn.bind(this);
    this.onClickSignUp = this.onClickSignUp.bind(this);
    this.onClose = this.onClose.bind(this);
    this.metadata = this.metadata.bind(this);
    this.renderMembershipModal = this.renderMembershipModal.bind(this);
    this.renderIconWithSpan = this.renderIconWithSpan.bind(this);
    this.renderIcon = this.renderIcon.bind(this);
    this.handleLoveOrUnLove = this.handleLoveOrUnLove.bind(this);
  }

  renderIconWithSpan(icon) {
    return <span className="icon favorite-icon">{icon}</span>;
  }

  renderIcon() {
    return this.props.love ? this.heartFilledIcon() : this.heartIcon();
  }

  heartIcon() {
    return <FashionIcon ariaHidden={true} name="heart" />;
  }

  heartFilledIcon() {
    return <FashionIcon ariaHidden={true} name="heart_filled" />;
  }

  metadata() {
    return { applicationName: "fashion", userAction: "attempted to favorite" };
  }

  onClickLogIn() {
    this.setState({ openModalType: "LOG_IN" });
  }

  onClickSignUp() {
    this.setState({ openModalType: "SIGN_UP" });
  }

  onClose() {
    this.setState({ renderMembershipModal: false, openModalType: null });
    if (this.props.isLoggedIn && !this.props.love) {
      this.props.loveImage(this.props.favorite_params);
    }
  }

  renderMembershipModal() {
    if (this.state.renderMembershipModal) {
      return (
        <MembershipModalRedux
          metadata={this.metadata()}
          openModalType={this.state.openModalType}
          onClickLogIn={this.onClickLogIn}
          onClickSignUp={this.onClickSignUp}
          onClose={this.onClose}
          onSignUpSuccess={this.onClose}
          onLogInSuccess={this.onClose}
          additionalMembershipData={{
            application: "fashion",
            action: "attempted to favorite",
          }}
        />
      );
    }
  }

  handleLoveOrUnLove() {
    if (!this.props.love) {
      this.props.loveImage(this.props.favorite_params);
    } else {
      this.props.unloveImage(
        this.props.favorite.id,
        this.props.favorite_params.object
      );
    }
  }

  handleClickHeart(e) {
    if (!this.props.isLoggedIn) {
      this.setState({ renderMembershipModal: true, openModalType: "LOG_IN" });
    } else {
      this.handleLoveOrUnLove();
    }
  }

  render() {
    let className = `${this.props.classes} ${
      this.props.love ? "favorited liked" : "favorite unliked"
    }`;
    return (
      <>
        {this.renderMembershipModal()}
        <div className={`favorite-container ${this.props.containerClasses}`}>
          <a
            aria-label={this.props.love ? "unfavorite" : "access favorited"}
            noHref
            data-xo-love="true"
            id={this.props.id}
            data-params={JSON.stringify(this.props.favorite_params)}
            className={className}
            onClick={this.handleClickHeart}
            role="button"
            tabIndex={0}
          >
            {this.props.border == "round"
              ? this.renderIconWithSpan(this.renderIcon())
              : this.renderIcon()}
          </a>
        </div>
      </>
    );
  }
}

function getFavorite(favorites, favorite_params) {
  return favorites.find(function (favorite) {
    return (
      favorite.item === favorite_params.object &&
      favorite.image_id === favorite_params.image_id
    );
  });
}

export function mapStateToProps(state, ownProps) {
  let favorite = getFavorite(
    state.favoriteData.favorites,
    ownProps.favorite_params
  );

  return {
    love: !!favorite,
    isLoggedIn: !!state.membership.member,
    favorite: favorite,
  };
}

export const mapDispatchToProps = {
  loveImage: loveImage,
  unloveImage: unloveImage,
};

export default connect(mapStateToProps, mapDispatchToProps)(FavoriteComponent);
